import { render, staticRenderFns } from "./knowledge-detail.vue?vue&type=template&id=4eecedba&scoped=true"
import script from "./knowledge-detail.vue?vue&type=script&lang=js"
export * from "./knowledge-detail.vue?vue&type=script&lang=js"
import style0 from "./knowledge-detail.vue?vue&type=style&index=0&id=4eecedba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eecedba",
  null
  
)

export default component.exports